"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var auth_1 = require("./auth");
var toolkit_1 = require("@reduxjs/toolkit");
var dashboard_1 = require("./dashboard");
var districts_1 = require("./districts");
var errors_1 = require("./errors");
var questions_1 = require("./questions");
var rosters_1 = require("./rosters");
var user_1 = require("./user");
var appReducer = toolkit_1.combineReducers({
    auth: auth_1.default,
    dashboard: dashboard_1.default,
    districts: districts_1.default,
    errors: errors_1.default,
    questions: questions_1.default,
    rosters: rosters_1.default,
    user: user_1.default,
});
var rootReducer = function (state, action) {
    if (action.type === 'USER_LOGOUT') {
        state = undefined;
    }
    return appReducer(state, action);
};
exports.default = rootReducer;
